export const AUTHENTICATION = "authentication";
export const USER_TOKEN = "W2G_UserToken";
export const USER_DATA = "UserData";
export const USER_DETAIL = "W2G_UserDetail";
export const RESET_TOKEN = "ResetToken";
export const RECENT_SEARCHES = "recent_searches";
export const RECENT_VIEWED_NEWS = "recent_viewed_news";
export const ADD_TO_CARTS_DATA = "AddToCartsData";
export const LOCAL_CART_DATA = "LocalCartData";
export const PLAYERS_DETAIL = "PlayersDetail";
export const LANGUAGE = "W2G_Language";

export const get = async (key) => {
  try {
    return await localStorage.getItem(key);
  } catch (e) {}
};

export const save = async (key, value) => {
  try {
    await localStorage.setItem(key, value);
  } catch (e) {}
};

export const remove = async (key) => {
  try {
    await localStorage.removeItem(key);
  } catch (e) {}
};
